import React from 'react'

const ContactUs = () => {
  return (
    <div>
      CONTACT US
    </div>
  )
}

export default ContactUs
